import { HeatMap } from '../models/map.heatMap';
import { MapLatLng } from '../models/map.latlng';
import { MapMarker } from '../models/map.marker';

declare var H: any;

export class HMapHeatMap extends HeatMap {
    constructor(id: number, map: any, points: MapLatLng[], markers: MapMarker[], opacity: number, maxIntensity: number) {
        super(id, map, points);
        // Creo el array con los puntos
        const data: any = [];
        if (points) {
            points.forEach(point => {
                data.push({ lat: point.lat, lng: point.lng, rad: 10, value: point.weight });
            });
        }
        if (markers) {
            markers.forEach(marker => {
                data.push({ lat: marker.position.lat, lng: marker.position.lng, value: marker.position.weight });
            });
        }
        this.heatMap = new H.data.heatmap.Provider({
            //type: 'value', 
            type: 'dentisy',
            colors: new H.data.heatmap.Colors({
                '0': 'rgba(0, 0, 0, 0)',         // Negro
                '0.1': 'rgba(0, 255, 0, 255)',   // Verde
                '0.5': 'rgba(255, 255, 0, 255)', // Amarillo
                '1': 'rgba(255, 0, 0, 255)'      // Rojo
            }, true),
            opacity: opacity,
            assumeValues: true,
            coarseness: 0,
            dataMax: maxIntensity
        });
        this.heatMap.addData(data);
        map.addLayer(new H.map.layer.TileLayer(this.heatMap));
    }

}
